import { Table } from "@/components/Tables/models/Table";


export class QueueTablesArgs {

    // Flattened tables
    constructor(public readonly tables: Array<Table>,
        public readonly parentExecutionId?: string,
        public name?: string,
    ) {
        if (tables == null) throw Error("tables are required");
    }

}